<ng-template
  let-extraClass="extraClass"
  #topNav>
  <tidy-top-nav
    [class]="extraClass"
    [canGoBack]="true"
    [title]="'Accepted Proposal'" />
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>
    <ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'desktop' }" />

    <ng-container *ngIf="loaded">

      <tidy-card>
        <tidy-row class="extra-bottom-padding">
          <tidy-grid>
            <tidy-row>
              <ion-row>
                <ion-col>
                  <tidy-row>
                    <tidy-text
                      [title]="'Proposal From'" />
                  </tidy-row>
                  <tidy-row>
                    <tidy-text
                      [body]="ownerName" />
                  </tidy-row>
                  <tidy-row>
                    <tidy-text
                      [body]="ownerEmail" />
                  </tidy-row>
                  <tidy-row>
                    <tidy-text
                      [body]="ownerPhone | telephone:'format'" />
                  </tidy-row>
                </ion-col>
              </ion-row>
            </tidy-row>
          </tidy-grid>
        </tidy-row>

        <tidy-row class="extra-bottom-padding">
          <!--TODO divider to have [color] input and add dynamic color-->
          <tidy-divider
            class="full-card-width thick"
            style="background: #4DAEED" />
        </tidy-row>

        <div style="margin-top: -15px; background: #292929; margin-left: -15px; margin-right: -15px; padding: 15px; padding-top:10px ">
          <tidy-row [alignLastItemRight]="true">
            <tidy-text
              [body]="'To:'" /><span>&nbsp;</span>
            <tidy-text
              [body]="clientName | titlecase" />
            <div>
              <tidy-text
                [body]="'Sent'" /><span>&nbsp;</span>
              <tidy-text
                [body]="createdAt | parseDateTime:'MMM d':'local'" />
            </div>
          </tidy-row>
          <tidy-row>
            <tidy-text
              *ngIf="!address"
              [body]="'Valid At: All Properties'" />
            <ng-container *ngIf="address">
              <tidy-text
                [body]="'Valid At:'" /><span>&nbsp;</span>
              <tidy-text
                [body]="address?.address + ','" /><span>&nbsp;</span>
              <ng-container *ngIf="address?.unit">
                <tidy-text
                  [body]="'Unit'" /><span>&nbsp;</span>
                <tidy-text
                  [body]="address?.unit + ','" /><span>&nbsp;</span>
              </ng-container>
              <tidy-text
                [body]="address?.zip" />
            </ng-container>
          </tidy-row>
        </div>

        <tidy-row class="extra-top-padding" [alignLastItemRight]="true">
          <tidy-text
            [body]="'Service'" />
          <tidy-text
            [body]="'Cost'" />
        </tidy-row>

        <tidy-row class="extra-bottom-padding">
          <tidy-divider />
        </tidy-row>

        <tidy-row [alignLastItemRight]="true">
          <div style="width:85%">
            <tidy-text
              [header]="serviceName | titlecase" />
          </div>
          <div>
            <tidy-text
              [body]="servicePrice | tcurrency" />
          </div>
        </tidy-row>

        <tidy-row style="width:85%" class="extra-bottom-padding">
          <tidy-text
            [body]="serviceDescription" />
        </tidy-row>

        <tidy-row [align]="'center'" class="extra-top-padding">
          <tidy-text
            [body]="'We are proud to offer this option for 30 days:'" />
        </tidy-row>

        <tidy-row class="no-padding" [align]="'center'">
          <tidy-text
            [body]="ownerName"
            class="signature" />
        </tidy-row>

        <tidy-divider
          style="margin-top:-15px" />
      </tidy-card>

      <tidy-button
        [action]="boundBookJob"
        [text]="'Schedule Job'"
        class="primary" />

    </ng-container>
  </tidy-wrapper>
</ng-template>

<app-scroll-wrapper [templateContent]="content" /><ng-template #content>
